import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DynamicFieldFormPage from "../../components/DynamicField/DynamicFieldFormPage";

const EditDynamicFieldPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb
          id="title"
          title2="Preferences"
          link2="/preferences"
          title="Edit Preference"
        />
        <DynamicFieldFormPage />
      </MasterLayout>
    </>
  );
};

export default EditDynamicFieldPage;
